import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, map, of, timeout } from 'rxjs';
import { environment } from '@env/environment';

export type BackendHealthStatus = 'checking' | 'live' | 'down';

@Injectable({ providedIn: 'root' })
export class ApiHealthService {
  private http = inject(HttpClient);

  checkBackend() {
    return this.http.get(`${environment.backendUrl}/actuator/health`).pipe(
      timeout(15000),
      map(() => 'live' as BackendHealthStatus),
      catchError(() => of('down' as BackendHealthStatus)),
    );
  }
}
